const BASE_URL = `${process.env.REACT_APP_URL_SIDE}/api/reports`;

export const getPortabilitySalesData = async (fpsId, month, year) => {
    try {
        const url = `${BASE_URL}/portability-sales?fpsId=${fpsId}&month=${month}&year=${year}`;
        
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            }
        });

        if (!response.ok) {
            throw new Error(`Error: ${response.status} ${response.statusText}`);
        }

        const data = await response.json();
        return data;

    } catch (error) {
        console.error("Service Error:", error);
        throw error;
    }
};